module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_efo-95a2b582a7fa47461406657b0ec929ce.svg";